var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_PubSubData_class = function (in_implements) {
    return new Class({
        Extends: OCS.Functions.define_Data_class(in_implements),
        class_name: "PubSubData",
        data_type: 'PubSubData',
        options: {
            entry: {
                json: {
                    data: {},
                    dataset: '',
                    info: {
                        timestamp: 0,
                        variables: []
                    },
                    payload: false,
                    provider: ''

                }
            },
            from: '',
            id: '',
            node: ''
        },
        get_data_obj: function () {
            var obj = this.parent();
            return Object.append(obj, {from: this.options.from, id: this.options.id, node: this.options.node});
        }
    });
};
OCS.Classes.PubSubData = OCS.Functions.define_PubSubData_class();
